<div class="sc-page">

  <!-- ============================================================
       HERO — Summer Sky / Beach Banner
       ============================================================ -->
  <section class="sc-hero">

    <!-- Animated sun + rays -->
    <div class="sc-sun"></div>
    <div class="sc-sun-rays"></div>

    <!-- Clouds drifting across sky -->
    <div class="sc-cloud sc-cloud-1"></div>
    <div class="sc-cloud sc-cloud-2"></div>
    <div class="sc-cloud sc-cloud-3"></div>

    <!-- Ocean waves -->
    <div class="sc-ocean">
      <div class="sc-wave sc-wave-1"></div>
      <div class="sc-wave sc-wave-2"></div>
      <div class="sc-wave sc-wave-3"></div>
    </div>

    <!-- Sandy beach -->
    <div class="sc-beach"></div>

    <!-- Palm trees — SVG inline so they look crisp -->
    <div class="sc-palm-wrap left">
      <svg class="sc-palm-svg" viewBox="0 0 180 280" fill="none" xmlns="http://www.w3.org/2000/svg">
        <!-- trunk -->
        <path d="M90 280 C85 240 78 200 82 160 C86 120 90 100 88 70" stroke="#8B5E3C" stroke-width="14" stroke-linecap="round" fill="none"/>
        <!-- fronds -->
        <path d="M88 70 C60 55 30 40 10 20" stroke="#2DC653" stroke-width="8" stroke-linecap="round" fill="none"/>
        <path d="M88 70 C80 45 75 20 80 0"  stroke="#2DC653" stroke-width="8" stroke-linecap="round" fill="none"/>
        <path d="M88 70 C110 55 140 45 160 30" stroke="#2DC653" stroke-width="8" stroke-linecap="round" fill="none"/>
        <path d="M88 70 C95 50 110 30 120 10"  stroke="#2DC653" stroke-width="8" stroke-linecap="round" fill="none"/>
        <path d="M88 70 C70 60 50 65 30 70"    stroke="#52B788" stroke-width="7" stroke-linecap="round" fill="none"/>
        <path d="M88 70 C105 65 130 70 155 60"  stroke="#52B788" stroke-width="7" stroke-linecap="round" fill="none"/>
        <!-- coconuts -->
        <circle cx="85" cy="72" r="7" fill="#C49020"/>
        <circle cx="94" cy="68" r="6" fill="#C49020"/>
      </svg>
    </div>

    <div class="sc-palm-wrap right">
      <svg class="sc-palm-svg" viewBox="0 0 180 280" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M90 280 C95 240 100 200 96 160 C92 120 88 100 92 70" stroke="#8B5E3C" stroke-width="14" stroke-linecap="round" fill="none"/>
        <path d="M92 70 C120 55 150 40 170 20" stroke="#2DC653" stroke-width="8" stroke-linecap="round" fill="none"/>
        <path d="M92 70 C100 45 105 20 100 0"  stroke="#2DC653" stroke-width="8" stroke-linecap="round" fill="none"/>
        <path d="M92 70 C70 55 40 45 20 30" stroke="#2DC653" stroke-width="8" stroke-linecap="round" fill="none"/>
        <path d="M92 70 C85 50 70 30 60 10"  stroke="#2DC653" stroke-width="8" stroke-linecap="round" fill="none"/>
        <path d="M92 70 C110 60 130 65 150 70"  stroke="#52B788" stroke-width="7" stroke-linecap="round" fill="none"/>
        <path d="M92 70 C75 65 50 70 25 60"    stroke="#52B788" stroke-width="7" stroke-linecap="round" fill="none"/>
        <circle cx="95" cy="72" r="7" fill="#C49020"/>
        <circle cx="86" cy="68" r="6" fill="#C49020"/>
      </svg>
    </div>

    <!-- Hero content -->
    <div class="sc-container">
      <div class="sc-hero-content">

        

        <div class="sc-hero-pill">11+ &amp; GCSE</div>

        <h1 class="sc-hero-title"><em>SUMMER</em></h1>
        <div class="sc-hero-subtitle">Intensive Course</div>

        <div style="margin-bottom:20px">
          <div class="sc-boards-strip">
            <div class="sc-board-item">CSSE</div>
            <div class="sc-board-item">GL</div>
            <div class="sc-board-item">FSCE</div>
            <div class="sc-board-item">SET</div>
            <div class="sc-board-item">ISEB</div>
            <div class="sc-board-date">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="margin-right:4px;vertical-align:middle"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>
              FROM 19 JULY
            </div>
          </div>
        </div>

        <div class="sc-hero-actions">
          <button class="sc-btn-book" (click)="scrollToBook()">
            Book Now
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14M12 5l7 7-7 7"/></svg>
          </button>
          <button class="sc-btn-outline" (click)="downloadBrochure()">
            Download Brochure
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg>
          </button>
        </div>

        <div class="sc-early-bird">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>
          EARLY BIRD DISCOUNT — BOOK BEFORE DATES FILL UP!
        </div>

      </div>
    </div>
  </section>

  <!-- ============================================================
       COURSE CHOOSER — Bootcamp vs Intensive
       ============================================================ -->
  <section class="sc-chooser" id="courses">
    <div class="sc-container">

      <div class="sc-chooser-header sc-reveal sc-hidden">
        <p class="sc-eyebrow">Two Powerful Options</p>
        <h2 class="sc-section-title">Choose Your <span>Summer Path</span></h2>
      </div>

      <div class="sc-course-grid">

        <!-- BOOTCAMP CARD -->
        <div class="sc-course-card sc-reveal sc-hidden d1">
          <div class="sc-card-header bootcamp">
            <div class="sc-card-tag">11+ Subject Bootcamp</div>
            <div class="sc-card-title">Summer Bootcamp Course</div>
            <div class="sc-card-tagline">Ideal for focused revision — tackle each subject in depth over 8 days</div>
            <div class="sc-card-start">
              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>
              Starting 19 July
            </div>
          </div>

          <div class="sc-card-body">

            <!-- Subjects -->
            <div class="sc-subjects">
              <div class="sc-subject-row">
                <span>Maths</span>
                <span class="sc-subject-pill">12 sessions / 8 Days</span>
              </div>
              <div class="sc-subject-row">
                <span>English (CW + Comprehension)</span>
                <span class="sc-subject-pill">12 sessions / 8 Days</span>
              </div>
              <div class="sc-subject-row">
                <span>Verbal Reasoning (VR)</span>
                <span class="sc-subject-pill">12 sessions / 8 Days</span>
              </div>
              <div class="sc-subject-row">
                <span>Non-Verbal Reasoning (NVR)</span>
                <span class="sc-subject-pill">12 sessions / 8 Days</span>
              </div>
            </div>

            <!-- Highlights grid -->
            <div class="sc-highlights">
              <div class="sc-highlight-item">
                <div class="sc-hi-icon">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>
                </div>
                <div>
                  <span class="sc-hi-num">12 hrs</span>
                  <span class="sc-hi-label">Expert Tuition</span>
                </div>
              </div>
              <div class="sc-highlight-item">
                <div class="sc-hi-icon red">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/></svg>
                </div>
                <div>
                  <span class="sc-hi-num">720+</span>
                  <span class="sc-hi-label">Exam Questions</span>
                </div>
              </div>
              <div class="sc-highlight-item">
                <div class="sc-hi-icon">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>
                </div>
                <div>
                  <span class="sc-hi-num">2</span>
                  <span class="sc-hi-label">F2F Mock Exams</span>
                </div>
              </div>
              <div class="sc-highlight-item">
                <div class="sc-hi-icon red">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 12 19.79 19.79 0 0 1 1.61 3.36 2 2 0 0 1 3.6 1.18h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 8.84a16 16 0 0 0 6 6l.91-.91a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7a2 2 0 0 1 1.72 2.03z"/></svg>
                </div>
                <div>
                  <span class="sc-hi-num">1 PTM</span>
                  <span class="sc-hi-label">Parent Meeting</span>
                </div>
              </div>
              <div class="sc-highlight-item">
                <div class="sc-hi-icon">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="22 12 18 12 15 21 9 3 6 12 2 12"/></svg>
                </div>
                <div>
                  <span class="sc-hi-num">150–250</span>
                  <span class="sc-hi-label">Cohort Benchmarking</span>
                </div>
              </div>
              <div class="sc-highlight-item">
                <div class="sc-hi-icon red">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 11l3 3L22 4"/><path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"/></svg>
                </div>
                <div>
                  <span class="sc-hi-num">12</span>
                  <span class="sc-hi-label">Assignments + Tests</span>
                </div>
              </div>
            </div>

          </div>

          <div class="sc-card-footer">
            <span class="sc-footer-text">Supportive Customer Success Team</span>
            <a class="sc-card-cta" [routerLink]="['/summer-bootcamp']">
              Book Bootcamp
              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14M12 5l7 7-7 7"/></svg>
            </a>
          </div>
        </div>

        <!-- INTENSIVE CARD -->
        <div class="sc-course-card sc-reveal sc-hidden d2">
          <div class="sc-card-header intensive">
            <div class="sc-card-tag">The Ultimate 11+ Prep Plan</div>
            <div class="sc-card-title">Summer Intensive Course</div>
            <div class="sc-card-tagline">105 sessions of total confidence — 6 to 7 weeks of comprehensive preparation</div>
            <div class="sc-card-start">
              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>
              Starting 19 July
            </div>
          </div>

          <div class="sc-card-body">

            <!-- Subjects -->
            <div class="sc-subjects">
              <div class="sc-subject-row">
                <span>Maths</span>
                <span class="sc-subject-pill red">28 Sessions / 6-7 weeks</span>
              </div>
              <div class="sc-subject-row">
                <span>English (CW + Comprehension)</span>
                <span class="sc-subject-pill red">28 Sessions / 6-7 weeks</span>
              </div>
              <div class="sc-subject-row">
                <span>Verbal Reasoning (VR)</span>
                <span class="sc-subject-pill red">14 Sessions / 6-7 weeks</span>
              </div>
              <div class="sc-subject-row">
                <span>Non-Verbal Reasoning (NVR)</span>
                <span class="sc-subject-pill red">14 Sessions / 6-7 weeks</span>
              </div>
              <div class="sc-subject-row">
                <span>Doubt-Clearing Sessions</span>
                <span class="sc-subject-pill red">21 Sessions / 6-7 weeks</span>
              </div>
            </div>

            <!-- Highlights grid -->
            <div class="sc-highlights">
              <div class="sc-highlight-item">
                <div class="sc-hi-icon">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>
                </div>
                <div>
                  <span class="sc-hi-num">105 hrs</span>
                  <span class="sc-hi-label">Expert Tuition</span>
                </div>
              </div>
              <div class="sc-highlight-item">
                <div class="sc-hi-icon red">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/></svg>
                </div>
                <div>
                  <span class="sc-hi-num">1680+</span>
                  <span class="sc-hi-label">Exam Questions</span>
                </div>
              </div>
              <div class="sc-highlight-item">
                <div class="sc-hi-icon">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>
                </div>
                <div>
                  <span class="sc-hi-num">5</span>
                  <span class="sc-hi-label">F2F Mock Exams</span>
                </div>
              </div>
              <div class="sc-highlight-item">
                <div class="sc-hi-icon red">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 12 19.79 19.79 0 0 1 1.61 3.36 2 2 0 0 1 3.6 1.18h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 8.84a16 16 0 0 0 6 6l.91-.91a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7a2 2 0 0 1 1.72 2.03z"/></svg>
                </div>
                <div>
                  <span class="sc-hi-num">7 PTMs</span>
                  <span class="sc-hi-label">Parent Meetings</span>
                </div>
              </div>
              <div class="sc-highlight-item">
                <div class="sc-hi-icon">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="22 12 18 12 15 21 9 3 6 12 2 12"/></svg>
                </div>
                <div>
                  <span class="sc-hi-num">150–250</span>
                  <span class="sc-hi-label">Cohort Benchmarking</span>
                </div>
              </div>
              <div class="sc-highlight-item">
                <div class="sc-hi-icon red">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 11l3 3L22 4"/><path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"/></svg>
                </div>
                <div>
                  <span class="sc-hi-num">21</span>
                  <span class="sc-hi-label">Assignments + Tests</span>
                </div>
              </div>
            </div>

          </div>

          <div class="sc-card-footer red">
            <span class="sc-footer-text">Supportive Customer Success Team</span>
            <a class="sc-card-cta" [routerLink]="['/summer-intensive']">
              Book Intensive
              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14M12 5l7 7-7 7"/></svg>
            </a>
          </div>
        </div>

      </div>
    </div>
  </section>

  <!-- ============================================================
       WHAT'S INCLUDED IN EVERY COURSE
       ============================================================ -->
  <section class="sc-included">
    <div class="sc-container">

      <div class="sc-included-header sc-reveal sc-hidden">
        <p class="sc-eyebrow">Always Included</p>
        <h2 class="sc-section-title">Everything Your Child <span>Needs to Succeed</span></h2>
      </div>

      <div class="sc-included-grid">

        <div class="sc-inc-card sc-reveal sc-hidden">
          <div class="sc-inc-icon sun">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"/><path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"/></svg>
          </div>
          <span class="sc-inc-num">Pre-Lecture</span>
          <div class="sc-inc-title">Materials &amp; Summary Notes</div>
          <p class="sc-inc-text">Ideal for fast, effective revision before each session starts.</p>
        </div>

        <div class="sc-inc-card sc-reveal sc-hidden d1">
          <div class="sc-inc-icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/></svg>
          </div>
          <span class="sc-inc-num">Proven</span>
          <div class="sc-inc-title">Tips, Tricks &amp; Techniques</div>
          <p class="sc-inc-text">Strategies to decode and tackle the most challenging 11+ questions with confidence.</p>
        </div>

        <div class="sc-inc-card sc-reveal sc-hidden d2">
          <div class="sc-inc-icon coral">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="20" x2="18" y2="10"/><line x1="12" y1="20" x2="12" y2="4"/><line x1="6" y1="20" x2="6" y2="14"/></svg>
          </div>
          <span class="sc-inc-num coral">RAR</span>
          <div class="sc-inc-title">Cohort Performance Report</div>
          <p class="sc-inc-text">Standard score, rank, percentile — benchmarked among 150–250 students per cohort.</p>
        </div>

        <div class="sc-inc-card sc-reveal sc-hidden d3">
          <div class="sc-inc-icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>
          </div>
          <span class="sc-inc-num">Expert</span>
          <div class="sc-inc-title">Parent-Teacher Meetings</div>
          <p class="sc-inc-text">Personalised progress discussions with dedicated guidance for each student.</p>
        </div>

        <div class="sc-inc-card sc-reveal sc-hidden d4">
          <div class="sc-inc-icon palm">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"/></svg>
          </div>
          <span class="sc-inc-num">Real</span>
          <div class="sc-inc-title">F2F Mock Exam Papers</div>
          <p class="sc-inc-text">Choose CSSE, FSCE or GL format — papers sat in true exam conditions.</p>
        </div>

        <div class="sc-inc-card sc-reveal sc-hidden d5">
          <div class="sc-inc-icon sun">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>
          </div>
          <span class="sc-inc-num">Always</span>
          <div class="sc-inc-title">Customer Success Support</div>
          <p class="sc-inc-text">Our dedicated team is here every step of the way — from booking to results day.</p>
        </div>

      </div>
    </div>
  </section>

  <!-- ============================================================
       COMPARISON TABLE — Bootcamp vs Intensive
       ============================================================ -->
  <section class="sc-compare">
    <div class="sc-container">

      <div class="sc-compare-header sc-reveal sc-hidden">
        <p class="sc-eyebrow">Side by Side</p>
        <h2 class="sc-section-title">Bootcamp <span>vs</span> Intensive</h2>
      </div>

      <div class="sc-table-wrap sc-reveal sc-hidden d1">
        <table class="sc-table">
          <thead>
            <tr>
              <th style="background:var(--sc-sky-dk)">Feature</th>
              <th class="bootcamp-col">Bootcamp</th>
              <th class="intensive-col">Summer Intensive</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Expert Tuition Hours</td>
              <td>12 hours</td>
              <td>105 hours</td>
            </tr>
            <tr>
              <td>Duration</td>
              <td>8 Days per subject</td>
              <td>6–7 Weeks</td>
            </tr>
            <tr>
              <td>Total Sessions</td>
              <td>12 per subject</td>
              <td>105 sessions</td>
            </tr>
            <tr>
              <td>Assignments &amp; Practice Tests</td>
              <td>12 + 12</td>
              <td>21 + 21</td>
            </tr>
            <tr>
              <td>Exam-Style Questions</td>
              <td>720+</td>
              <td>1,680+</td>
            </tr>
            <tr>
              <td>F2F Mock Exams (CSSE/GL/FSCE)</td>
              <td>2</td>
              <td>5</td>
            </tr>
            <tr>
              <td>Parent-Teacher Meetings (PTM)</td>
              <td>1</td>
              <td>7</td>
            </tr>
            <tr>
              <td>Doubt-Clearing Sessions</td>
              <td>
                <span class="sc-table-check red">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
                </span>
              </td>
              <td>21 sessions
                <span class="sc-table-check" style="margin-left:6px">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
                </span>
              </td>
            </tr>
            <tr>
              <td>Cohort RAR Report</td>
              <td>
                <span class="sc-table-check">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
                </span>
              </td>
              <td>
                <span class="sc-table-check">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
                </span>
              </td>
            </tr>
            <tr>
              <td>Pre-Lecture Materials</td>
              <td>
                <span class="sc-table-check">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
                </span>
              </td>
              <td>
                <span class="sc-table-check">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
                </span>
              </td>
            </tr>
            <tr>
              <td>Best Suited For</td>
              <td>Focused revision, specific subjects</td>
              <td>Full prep from scratch, maximum results</td>
            </tr>
          </tbody>
        </table>
      </div>

    </div>
  </section>

  <!-- ============================================================
       TESTIMONIAL + TRUSTPILOT
       ============================================================ -->
  <section class="sc-testimonial">
    <div class="sc-container">
      <div class="sc-testi-inner">

        <div class="sc-testi-card sc-reveal sc-hidden">
          <div class="sc-stars">
            <svg class="sc-star" width="20" height="20" viewBox="0 0 24 24" fill="#FFD60A" stroke="#FFD60A" stroke-width="1"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>
            <svg class="sc-star" width="20" height="20" viewBox="0 0 24 24" fill="#FFD60A" stroke="#FFD60A" stroke-width="1"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>
            <svg class="sc-star" width="20" height="20" viewBox="0 0 24 24" fill="#FFD60A" stroke="#FFD60A" stroke-width="1"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>
            <svg class="sc-star" width="20" height="20" viewBox="0 0 24 24" fill="#FFD60A" stroke="#FFD60A" stroke-width="1"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>
            <svg class="sc-star" width="20" height="20" viewBox="0 0 24 24" fill="#FFD60A" stroke="#FFD60A" stroke-width="1"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>
          </div>
          <p class="sc-testi-text">
            "Big thanks to Sanjay and his team for creating such a great platform which was very helpful for our son's 11Plus preparation. We found all the topic wise tests and mock exams well structured and the detailed result analysis helped us understand the weaknesses that we need to work upon. The content is of great quality and really helped boost the confidence prior to real exams."
          </p>
          <div class="sc-testi-name">Sushil Shetty</div>
        </div>

        <div class="sc-testi-right sc-reveal sc-hidden d2">
          <h2 class="sc-testi-heading">
            Join <em>10,000+</em><br>
            Successful<br>
            <span>Students</span>
          </h2>
          <p class="sc-testi-sub">
            Sehyog has been guiding students to grammar school success since 2014. Our summer programmes are rated 5 stars on Trustpilot.
          </p>
          <button class="sc-btn-primary" [routerLink]="['/summer-bootcamp']">
            Book Your Place Today
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14M12 5l7 7-7 7"/></svg>
          </button>
        </div>

      </div>
    </div>
  </section>

  <!-- ============================================================
       CONTACT / BOOK NOW
       ============================================================ -->
  <section class="sc-contact" id="book">
    <div class="sc-container">
      <div class="sc-contact-inner">

        <div>
          <h2 class="sc-contact-title sc-reveal sc-hidden">
            Ready to <em>Start<br>This Summer</em>?
          </h2>
          <p class="sc-contact-sub sc-reveal sc-hidden d1">
            Get in touch today to secure your child's place. Limited spaces available — bookings fill up fast each year.
          </p>
          <div class="sc-contact-links sc-reveal sc-hidden d2">
            <a href="tel:+4403980844" class="sc-contact-link">
              <div class="sc-contact-icon">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 12 19.79 19.79 0 0 1 1.61 3.36 2 2 0 0 1 3.6 1.18h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 8.84a16 16 0 0 0 6 6l.91-.91a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7a2 2 0 0 1 1.72 2.03z"/></svg>
              </div>
              +44 (0) 3980 8244
            </a>
            <a href="tel:+447464772331" class="sc-contact-link">
              <div class="sc-contact-icon">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 12 19.79 19.79 0 0 1 1.61 3.36 2 2 0 0 1 3.6 1.18h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 8.84a16 16 0 0 0 6 6l.91-.91a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7a2 2 0 0 1 1.72 2.03z"/></svg>
              </div>
              +44 7464 772331
            </a>
            <a href="mailto:support@sehyog.co.uk" class="sc-contact-link">
              <div class="sc-contact-icon">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>
              </div>
              support@sehyog.co.uk
            </a>
            <a href="https://www.sehyog.co.uk" target="_blank" class="sc-contact-link">
              <div class="sc-contact-icon">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="2" y1="12" x2="22" y2="12"/><path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/></svg>
              </div>
              www.sehyog.co.uk
            </a>
          </div>

          <div class="sc-social-row" style="margin-top:28px;justify-content:flex-start">
            <a class="sc-social-btn" href="#" aria-label="LinkedIn">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"/><rect x="2" y="9" width="4" height="12"/><circle cx="4" cy="4" r="2"/></svg>
            </a>
            <a class="sc-social-btn" href="#" aria-label="Facebook">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"/></svg>
            </a>
            <a class="sc-social-btn" href="#" aria-label="YouTube">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M22.54 6.42a2.78 2.78 0 0 0-1.94-1.96C18.88 4 12 4 12 4s-6.88 0-8.6.46a2.78 2.78 0 0 0-1.94 1.96A29 29 0 0 0 1 12a29 29 0 0 0 .46 5.58A2.78 2.78 0 0 0 3.4 19.54C5.12 20 12 20 12 20s6.88 0 8.6-.46a2.78 2.78 0 0 0 1.94-1.96A29 29 0 0 0 23 12a29 29 0 0 0-.46-5.58z"/><polygon points="9.75 15.02 15.5 12 9.75 8.98 9.75 15.02"/></svg>
            </a>
            <a class="sc-social-btn" href="#" aria-label="Instagram">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="2" y="2" width="20" height="20" rx="5" ry="5"/><path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"/><line x1="17.5" y1="6.5" x2="17.51" y2="6.5"/></svg>
            </a>
          </div>
        </div>

        <!-- QR code -->
        <div class="sc-contact-right sc-reveal sc-hidden d3">
          <div class="sc-qr-wrap">
            <div class="sc-qr-label">Scan to Book</div>
            <div class="sc-qr-box">
              <!-- QR code SVG placeholder — replace with real QR image -->
              <img src="assets/images/sic_qrcode.png" alt="">
            </div>
            <div class="sc-qr-sub">Scan with your phone camera</div>
            <div style="margin-top:12px">
              <span style="font-size:11px;color:rgba(255,255,255,.4);font-weight:600">&#64;SehyogAcademy</span>
            </div>
          </div>
        </div>

      </div>
    </div>

    <!-- T&C note -->
    <div class="sc-container" style="margin-top:40px;text-align:center;position:relative;z-index:1">
      <p style="font-size:12px;color:rgba(255,255,255,.35);font-weight:600">* T&amp;C applies. All session counts are approximate and subject to scheduling. Early bird discount valid while places last.</p>
    </div>
  </section>

</div>

<!-- Scroll reveal is handled in the component TypeScript -->